import { IconProps } from './types';

export const Skolon = ({ size = 24, ...props }: IconProps) => (
  <svg width={size} height={size} viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <g clipPath="url(#clip0_507_8665)">
      <path
        d="M23.1383 5.66951C26.9377 5.36634 29.8712 8.41205 29.2243 12.2148C28.3185 17.541 20.5322 18.3455 18.394 13.4906C16.7748 9.81367 19.1906 5.98462 23.1383 5.66985V5.66951ZM26.4238 14.1017C28.5978 12.0293 27.7449 8.21084 24.8298 7.36101C21.8387 6.48934 19.1787 8.7865 19.6316 11.8704C20.0998 15.0576 24.171 16.2492 26.4234 14.1017H26.4238Z"
        fill="currentColor"
      />
      <path
        d="M7.90851 5.66934C10.3666 5.477 12.7797 6.75824 13.6855 9.09154C15.0411 12.5837 12.7378 16.425 8.96808 16.6784C1.03239 17.2114 0.543357 6.24533 7.90851 5.66934ZM7.9467 7.19987C4.04195 7.52384 3.01682 12.8599 6.34627 14.6704C8.60591 15.8991 11.5933 14.8307 12.259 12.2778C13.0041 9.42063 10.8638 6.95774 7.94636 7.19987H7.9467Z"
        fill="currentColor"
      />
      <path
        d="M7.33183 20.4338C7.38332 20.426 7.40037 20.4335 7.44027 20.4641C7.53201 20.5347 7.71991 20.8229 7.82018 20.9269C10.856 24.0743 16.4342 24.7219 20.4501 23.3769C22.2245 22.7824 23.7192 21.7696 25.0488 20.4727L25.1958 20.5034L26.1152 21.3454C26.2418 21.4494 25.9737 21.7041 25.8833 21.8071C21.3224 27.0044 11.076 26.8847 6.46153 21.7884C6.4131 21.7348 6.12903 21.4221 6.12255 21.3972C6.10754 21.3406 6.13005 21.3017 6.17541 21.2703C6.41753 21.166 7.14529 20.4631 7.33251 20.4341L7.33183 20.4338Z"
        fill="currentColor"
      />
      <path
        d="M16.7557 5.84961L16.7939 18.4011H21.4431C21.4472 18.4011 21.5004 18.4543 21.5004 18.4584V19.9316H15.1863V5.84961H16.7553H16.7557Z"
        fill="currentColor"
      />
      <path
        d="M24.4087 9.10261C24.4186 9.14523 24.4039 9.17695 24.3886 9.21514C24.2637 9.52582 23.9971 9.86616 23.8552 10.213C23.742 10.4896 23.6403 10.7931 23.6056 11.0918C23.9531 10.6775 24.4056 10.36 24.9076 10.1557C24.9925 10.1213 25.3622 9.97938 25.4174 9.98961C25.6197 10.0278 25.8011 10.7 25.8198 10.8858C26.0974 13.6297 22.3751 14.3425 21.5976 11.8936C21.0383 10.1315 22.6497 8.43828 24.4083 9.10226L24.4087 9.10261Z"
        fill="currentColor"
      />
      <path
        d="M9.21429 9.10568C9.23134 9.15649 9.20679 9.1998 9.18735 9.24448C9.06458 9.53128 8.80403 9.84775 8.66353 10.1751C8.52985 10.4865 8.41663 10.8313 8.3757 11.1686L8.75765 10.7665C9.10175 10.4998 9.52258 10.2372 9.94613 10.1182C10.2773 10.0251 10.323 10.0756 10.4604 10.404C11.3164 12.4467 8.63182 14.4165 6.93487 12.8007C5.212 11.1604 6.9451 8.19821 9.21429 9.10568Z"
        fill="currentColor"
      />
    </g>
  </svg>
);
